//#region Imports

import { default as ContentService } from '../services/common/content-service';

import ProfileService from '../components/accounts/profile/profile-service';
import { default as BuildingsService } from '../services/buildings-service';
import { default as RegisterService } from '../components/accounts/register/register-service';

import { default as BuildingDocumentsDataService } from '../components/building-documents/building-documents-service';

import { default as FinancialsService } from '../components/financials/financials-service';
import { default as LevyRollService } from '../components/financials/levy-roll/levy-roll-service';
import { default as BalanceSheetService } from '../components/financials/balance-sheet/balance-sheet-service';
import { default as ContractorsDataService } from '../components/financials/contractors-roll/contractors-roll-service';
import { default as IncomeStatementService } from '../components/financials/income-statement/income-statement-service';
import { default as IncomeVSBudgetService } from '../components/financials/income-vs-budget/income-vs-budget-service';
import { default as DebtorAgeAnalysisService } from '../components/financials/debtor-age-analysis/debtor-age-analysis-service';
import { default as ContractorsRollService } from '../components/financials/contractors-roll/contractors-roll-service';
import { default as CashflowStatementDataService } from '../components/financials/cashflow-statement/cashflow-statement-service';
import { default as CashflowStatementDataNewService } from '../components/financials/cashflow-statement-new/cashflow-statement-new-service';

import { default as ClearanceCaptureService } from '../components/clearances/clearance-capture-service';
import { default as ClearanceRequestService } from '../components/clearances/clearance-request/clearance-request-service';
import { default as PaymentApprovalsDataService } from '../components/payments/payment-approvals-service';
import { default as PersonalDocumentsDataService } from '../components/personal-documents/personal-documents-service';
import { default as AccountsHistoryDataService } from '../components/accounts/accounts-history/accounts-history-service';
import { default as FinancialSummaryService } from '../components/financials/financial-summary/financial-summary-service';
import { default as PaymentAuthorisationDataService } from '../components/payment-authorisation/payment-authorisation-service';
import { default as TenantDataService } from '../components/accounts/tenant/tenant-service';

import { default as AuthInterceptorService } from '../services/common/auth-interceptor-service';
import { default as CountriesUtilService } from '../services/common/countries/countries-util-service';

import { default as Utility } from '../services/common/utility-service';
import { default as PretorCache } from '../services/common/cache-service';
import { default as CommonService } from '../services/common/common-service';
import { default as PagingService } from '../services/common/paging-service';
import { default as NavigationService } from '../services/common/navigation-service';
import { default as NotificationService } from '../services/common/notification-service';
import { default as LocalStorageService } from '../services/common/local-storage-service';
import { default as AuthorizationService } from '../services/common/authorization-service';
import { default as InternalLinksService } from '../services/common/internal-links-service';
import { default as AuthenticationService } from '../services/common/authentication-service';

import { default as LayoutService } from '../services/common/layout-service';

import { default as UserUnitsService } from '../services/common/user-units-service';

import { default as DashboardService } from '../components/dashboard/dashboard-service';
import { default as ComplianceService } from '../components/compliance/compliance-service';
import { default as TelemetryService } from '../services/common/telemetry-service';
import { default as UtilityinfoService } from '../components/utility-info/utility-info-service';
import { default as ApprovalDocumentsDataService } from '../components/approval-documents/documents-approval-service';
import { default as AuditsCaptureService } from '../components/audits/audits-capture-service';
import { default as AuditorsDashboardService } from '../components/auditors-dashboard/auditors-dashboard-service';
import { default as RentalsCaptureService } from '../components/rentals/rentals-capture-service';
import { default as WagesRollService } from '../components/financials/wages-roll/wages-roll-service';
import { default as TrusteeDashboardService } from '../components/trustee-dashboard/trustee-dashboard-service';
import { default as FindAContractorService } from '../components/contractors/find-a-contractor-service';


//#endregion

export default angular
	.module('pretor.online.factories', [])
	.factory('Utility', Utility)
	.factory('PretorCache', PretorCache)
	.factory('CommonService', CommonService)
	.factory('LayoutService', LayoutService)
	.factory('PagingService', PagingService)
	.factory('ContentService', ContentService)
	.factory('ProfileService', ProfileService)
	.factory('RegisterService', RegisterService)
	.factory('BuildingsService', BuildingsService)
	.factory('UserUnitsService', UserUnitsService)
	.factory('DashboardService', DashboardService)
	.factory('TelemetryService', TelemetryService)
	.factory('TenantDataService', TenantDataService)
	.factory('FinancialsService', FinancialsService)
	.factory('NavigationService', NavigationService)
	.factory('ComplianceService', ComplianceService)
	.factory('LevyRollService', LevyRollService)
	.factory('LocalStorageService', LocalStorageService)
	.factory('NotificationService', NotificationService)
	.factory('BalanceSheetService', BalanceSheetService)
	.factory('InternalLinksService', InternalLinksService)
	.factory('CountriesUtilService', CountriesUtilService)
	.factory('AuthorizationService', AuthorizationService)
	.factory('AuthenticationService', AuthenticationService)
	.factory('ContractorsRollService', ContractorsRollService)
	.factory('ContractorsDataService', ContractorsDataService)
	.factory('AuthInterceptorService', AuthInterceptorService)
	.factory('IncomeStatementService', IncomeStatementService)
	.factory('IncomeVSBudgetService', IncomeVSBudgetService)
	.factory('DebtorAgeAnalysisService', DebtorAgeAnalysisService)
	.factory('ClearanceCaptureService', ClearanceCaptureService)
	.factory('ClearanceRequestService', ClearanceRequestService)
	.factory('FinancialSummaryService', FinancialSummaryService)
	.factory('AccountsHistoryDataService', AccountsHistoryDataService)
	.factory('paymentApprovalsDataService', PaymentApprovalsDataService)
	.factory('CashflowStatementDataService', CashflowStatementDataService)
	.factory('CashflowStatementDataNewService', CashflowStatementDataNewService)
	.factory('personalDocumentsDataService', PersonalDocumentsDataService)
	.factory('buildingDocumentsDataService', BuildingDocumentsDataService)
	.factory('paymentAuthorisationDataService', PaymentAuthorisationDataService)
	.factory('UtilityinfoService',UtilityinfoService)
	.factory('ApprovalDocumentsDataService',ApprovalDocumentsDataService)
	.factory('AuditsCaptureService', AuditsCaptureService)
	.factory('AuditorsDashboardService', AuditorsDashboardService)
    .factory('RentalsCaptureService', RentalsCaptureService)
	.factory('WagesRollService', WagesRollService)
	.factory('TrusteeDashboardService', TrusteeDashboardService)
	.factory('FindAContractorService', FindAContractorService);
